import { SignUp } from '@clerk/clerk-react';
import { Logo } from '../components/Logo';

export function SignUpPage() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-8 bg-bg p-6 text-fg">
      <Logo />
      <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" forceRedirectUrl="/" />
    </div>
  );
}
